<template>
  <div class="form-group g-captcha" :class="{'error': not_filled_error === true}">
    <div
      class="g-recaptcha"
      data-callback="_captchaSubmitted"
      data-expired-callback="_captchaExpiredCallback"
      data-error-callback="_captchaErrorCallback"
      data-sitekey="6LfxoMgaAAAAAEV7_P7lEm53iS2rsHP2-M6PCUH7"></div>
  </div>
</template>
<script>

import { appendScript } from '@helpers/Global';

export default {
  name: 'GoogleCaptcha',
  data () {
    return {
      captcha_token: null,
      not_filled_error: false
    };
  },
  created () {
    this.bindGlobalEvents();
    this.loadCaptchaAPI();
  },
  methods: {
    loadCaptchaAPI () {
      const URL = 'https://www.google.com/recaptcha/api.js';
      const script = appendScript(URL);
      script.onload = this.bindGlobalEvents;
    },
    bindGlobalEvents () {
      window._captchaSubmitted = this.captchaSubmitted;
      window._captchaExpiredCallback = this._captchaExpiredCallback;
      window._captchaErrorCallback = this._captchaErrorCallback;
    },
    captchaSubmitted (token) {
      this.captcha_token = token;
      this.hideError();
    },
    _captchaErrorCallback () {
      this.captcha_token = null;
    },
    _captchaExpiredCallback () {
      this.captcha_token = null;
    },
    showError() {
      this.not_filled_error = true;
    },
    hideError() {
      this.not_filled_error = false;
    },
    getToken () {
      return this.captcha_token;
    },
    reset() {
      window.grecaptcha.reset();
      this.captcha_token = null;
    }
  },
};
</script>
